import { render, staticRenderFns } from "./WorkforceDetailBasic.vue?vue&type=template&id=1eeb9ae5&"
import script from "./WorkforceDetailBasic.vue?vue&type=script&lang=js&"
export * from "./WorkforceDetailBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports